// @flow
export const CHECK_SERVICE_OUTAGE_STATUS = 'hive/service_outage/CHECK_SERVICE_OUTAGE_STATUS';
export const RECEIVE_SERVICE_OUTAGE_STATUS = 'hive/service_outage/RECEIVE_SERVICE_OUTAGE_STATUS';
export const SHOW_ALERT_NOTIFICATION = 'hive/service_outage/SHOW_SERVICE_OUTAGE';
export const HIDE_ALERT_NOTIFICATION = 'hive/service_outage/HIDE_SERVICE_OUTAGE';



// WEBPACK FOOTER //
// ./src/core/state/service-outage/constants.js